import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'startWebCollaborationDialog.title',
    defaultMessage:
      'Questionario MiFID in web collaboration',
  },
  content: {
    id: 'startWebCollaborationDialog.content',
    defaultMessage: 'Cliccando su “PROCEDI” darai inizio alla sessione di Web Collaboration con il tuo “Consulente Finanziario” al fine di compilare il questionario MiFID.',
  },
  continuedButton: {
    id: 'startWebCollaborationDialog.continueButton',
    defaultMessage: 'Procedi',
    description: 'Label for the "continued" button',
  },
});
